import request from "@/utils/request";

/**账号登录 */
export function postAccountLogin(data) {
  return request({
    url: "/api/v1/6459ea02ba473",
    method: "post",
    data,
  });
}

/**运营地区列表 */
export function postRegion(data) {
  return request({
    url: "/api/v1/6a881d880215a",
    method: "post",
    data,
  });
}

/**获取验证码 */
export function getSmsSend(data) {
  return request({
    url: "/api/v1/5b5bdc44796e8",
    method: "post",
    data,
  });
}

/**验证码修改密码  忘记密码*/
export function postEditPasswordCode(data) {
  return request({
    url: "/api/v1/6486ca3fadf64",
    method: "post",
    data,
  });
}

/**校验验证码 */
export function postUserCheckVerifyCode(data) {
  return request({
    url: "/api/v1/655886cbda89b",
    method: "post",
    data,
  });
}

/**更换绑定账号 */
export function postChangeAccount(data) {
  return request({
    url: "/api/v1/6486d2a264ce5",
    method: "post",
    data,
  });
}

/**用户注册 */
export function postUserRegister(data) {
  return request({
    url: "/api/v1/645b0ae5e26ba",
    method: "post",
    data,
  });
}